/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, {Component} from 'react';
// fields
import Field from 'material/form/field/field_container';
import Form from 'material/form/form';

// grid
import Grid from 'material/grid/grid';
import GridSet from 'material/grid/gridset/gridset';
import GridItem from 'material/grid/griditem/griditem';
//styles
import styles from 'pages/dashboard/account/paymentinfo/selectmethod/paypal/paypal_styles';
import injectSheet from 'react-jss';



/* ========== ~~~~~~~~~~ PAYPAL : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Paypal extends Component {
    constructor(props){
        super(props);
        this.formName = 'PAYPAL';
    }

    componentDidMount(){
   if(this.props.paymentUUID)this.props.getPayPalInformation(false, this.formName, this.props.paymentUUID);
    }

    render() {

        return(
         <Form formName={this.formName} editable={this.props.editable}>
            <Grid  klass={`paypal ${this.props.classes.paypal}`}>
                <GridSet align={`horizontal`} >
                    <GridItem type={`full`}>
                        <Field type={`text`} name={`paypalUserName`} value={this.props.fields.paypalUserName.value} valid={this.props.fields.paypalUserName.valid} formName={this.formName} placeholder={`PayPal username`} label={`Paypal Username`} info={``} required />
                    </GridItem>
                </GridSet>
            </Grid>
         </Form>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(Paypal);